export default class WarrantyStatus {
  static PENDING_STATUS = 'Pending';
  static REJECT_STATUS = 'Reject';
  static APPROVED_STATUS = 'Approved';
  static EXPIRED_STATUS = 'Expired';
}
